exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{line-height:1.15}body{margin:0}svg{max-width:1.8rem}#app[data-v-4237df1f]{-webkit-transform:scale(.8);transform:scale(.8);max-width:128rem;margin-left:auto;margin-right:auto}#app[data-v-4237df1f],#mainapp[data-v-4237df1f]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#2c3e50;background-color:#fef0e0}#mainapp[data-v-4237df1f]{width:100%;overflow:hidden}@media (max-width:48rem){#app[data-v-4237df1f]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#2c3e50;background-color:#fef0e0;padding-bottom:5rem;width:100%;padding-left:0;padding-right:0;margin-left:auto;margin-right:auto}}", ""]);

// exports
